module.exports = __webpack_public_path__ + "img/jamendo.565c2886.svg";